// Important Note!
// These "Tables" are shaped this way to be compatible with the
// PrimeVue DataTable component.
import { type EODReportTable } from '@utilities/reports/types'

const initialServiceSales: EODReportTable = [
    {type: 'service', price: 300, amount: 0},
    {type: 'service', price: 275, amount: 0},
    {type: 'service', price: 250, amount: 0},
    {type: 'service', price: 225, amount: 0},
    {type: 'service', price: 200, amount: 0},
    {type: 'service', price: 175, amount: 0},
    {type: 'service', price: 150, amount: 0},
    {type: 'service', price: 125, amount: 0},
    {type: 'service', price: 100, amount: 0},
    {type: 'service', price: 75, amount: 0},
    {type: 'service', price: 70, amount: 0},
    {type: 'service', price: 65, amount: 0},
    {type: 'service', price: 60, amount: 0},
    {type: 'service', price: 55, amount: 0},
    {type: 'service', price: 50, amount: 0},
    {type: 'service', price: 45, amount: 0},
    {type: 'service', price: 40, amount: 0},
    {type: 'service', price: 35, amount: 0},
    {type: 'service', price: 32, amount: 0},
    {type: 'service', price: 30, amount: 0},
    {type: 'service', price: 25, amount: 0},
    {type: 'service', price: 20, amount: 0},
    {type: 'service', price: 15, amount: 0},
]

const initialServicesRendered: EODReportTable = [
    {type: 'NP', amount: 0},
    {type: 'TT', amount: 0},
    {type: 'IL', amount: 0},
    {type: 'DT', amount: 0},
    {type: 'DR', amount: 0},
    {type: 'RW', amount: 0},
    {type: 'ORW', amount: 0},
    {type: 'Permit', amount: 0},
    {type: 'PC', amount: 0},
    {type: 'PS', amount: 0},
    {type: 'Other', amount: 0},
]

const initialSmogSales: EODReportTable =
    [
        {type: 'smog', price: 0, amount: 0},
        {type: 'smog', price: 6, amount: 0},
        {type: 'smog', price: 15, amount: 0},
        {type: 'smog', price: 17, amount: 0},
        {type: 'smog', price: 18, amount: 0},
        {type: 'smog', price: 19, amount: 0},
        {type: 'smog', price: 20, amount: 0},
        {type: 'smog', price: 25, amount: 0},
        {type: 'smog', price: 26.99, amount: 0},
        {type: 'smog', price: 27, amount: 0},
        {type: 'smog', price: 29.99, amount: 0},
        {type: 'smog', price: 35, amount: 0},
        {type: 'smog', price: 45, amount: 0}
    ]


const initialRevenueTable: EODReportTable = [
    {type: "ones", label: "$1", price: 1, amount: 0},
    {type: "fives", label: "$5", price: 5, amount: 0},
    {type: "tens", label: "$10", price: 10, amount: 0},
    {type: "twenties", label: "$20", price: 20, amount: 0},
    {type: "fifties", label: "$50", price: 50, amount: 0},
    {type: "hundreds", label: "$100", price: 100, amount: 0},
    {type: "coins", label: "Change", price: 1, amount: 0},
    {type: "cc", label: "CC", price: 1, amount: 0}
]

export {
    initialServiceSales,
    initialServicesRendered,
    initialSmogSales,
    initialRevenueTable,
}